import { derived } from 'svelte/store';
import { locale, _, register, init, getLocaleFromNavigator } from 'svelte-i18n';

const MESSAGE_FILE_URL_TEMPLATE = 'https://tools.obyte.it/portals/lang/idrobyte/{locale}.json';

function setupI18n({ withLocale: _locale } = { withLocale: 'en' }) {
  const messagesFileUrl = MESSAGE_FILE_URL_TEMPLATE.replace('{locale}', _locale);

  return fetch(messagesFileUrl)
    .then(response => response.json())
    .then((messages) => {
      // dictionary.set({ [_locale]: messages });
      // console.log('in setup', messages);

      // locale.set(_locale);
      register('en', () => messages);
      register('it', () => messages);
      init({
        fallbackLocale: 'en',
        initialLocale: _locale, // getLocaleFromNavigator()
      })
    });
}

const isLocaleLoaded = derived(locale, $locale => typeof $locale === 'string');

export { _, setupI18n, isLocaleLoaded };
